<template>
  <el-dialog :title="params.title"
    :visible.sync="params.dialogVisible" :width="params.width" custom-class="fixed">
   <el-form :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
   <!-- <el-form-item label="手机号吗" prop="telephone">
       <div class="disFlex">
           <el-input class="flex2 marR10" type="number" v-model="ruleForm.telephone" ></el-input>
           <el-button class="flex1" :disabled="countdown > 0" @click="sendSmsCode">{{ countdown > 0 ? `${countdown}秒后重新发送` : '发送验证码' }}</el-button>
       </div>
      </el-form-item>
   <el-form-item label="验证码" prop="authCode" style="width: 200px;">
       <el-input v-model="ruleForm.authCode"></el-input>
   </el-form-item> -->
   <el-form-item label="旧密码" prop="oldPassword">
       <el-input type="password" v-model="ruleForm.oldPassword" show-password></el-input>
   </el-form-item>
   <el-form-item label="新密码" prop="newPasswordSure">
       <el-input type="password" v-model="ruleForm.newPasswordSure" show-password></el-input>
   </el-form-item>
   <el-form-item label="确认密码" prop="newPassword">
       <el-input type="password" v-model="ruleForm.newPassword" show-password></el-input>
   </el-form-item>
   
   <el-form-item label="手机号码" prop="phone">
       <el-input type="number" v-model="ruleForm.phone" ></el-input>
   </el-form-item>
   <el-form-item>
       <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
       <el-button @click="resetForm('ruleForm')">重置</el-button>
   </el-form-item>
   </el-form>
  </el-dialog>
</template>
<script>
import baseApi from '@/api/baseApi.js';
 export default {
   props: {
       params: {
           type: Object,
           default: function(){
               return {}
           }
       },
   },
   data() {
     return {
       ruleForm: {
        oldPassword:'',
        newPasswordSure:'',
        newPassword:'',
        phone:'',
       },
       smsCode: '',
       countdown: 0, // 倒计时
       rules: {
        oldPassword: [
               { required: true, message: '请输入旧密码', trigger: 'blur' },
           ],
           newPasswordSure: [
               { required: true, message: '请输入新密码', trigger: 'blur' },
           ],
           newPassword: [
               { required: true, message: '请输入确认密码', trigger: 'blur' },
           ],
       }
     }   
   },
   methods: {
      tableRowClassName({row, rowIndex}) {
        if (rowIndex % 2 == 0) {
          return 'warning-row';
        } else {
          return 'success-row';
        }
      },
     sendSmsCode() {
       // 模拟发送短信验证码的操作
       // 实际应用中，这里应该是发起一个API请求到服务器来发送短信
       if(!this.ruleForm.telephone){
           return this.$message({
                 message: '手机号码不能为空',
                 type: 'error',
                 duration:1500
               })
       }
       this.simulateSmsSending();
     },
     simulateSmsSending() {
       if (this.countdown > 0) return;
       this.countdown = 60; // 设置倒计时时间，例如60秒
       this.getCode();
       const intervalId = setInterval(() => {
         if (this.countdown > 0) {
           this.countdown -= 1;
         } else {
           clearInterval(intervalId);
         }
       }, 1000);
     },
     submitForm(formName) {
       this.$refs[formName].validate((valid) => {
         if (valid) {
           console.log("submit",this.ruleForm)
           this.$emit("listenDialog",{type:this.params.type,data:this.ruleForm})
         } else {
           console.log('error submit!!');
           return false;
         }
       });
     },
     resetForm(formName) {
       this.$refs[formName].resetFields();
     },
     
   //获取验证码
   getCode() {
       let data = {
           telephone:this.ruleForm.telephone,
           type:3,
       }
       baseApi.merchantGetAuthCode(data)
       .then( res => {
           this.fileList = res.data || [];
           console.log("sssssssssssssssss",res.data)
       });
   },
   }
 }
</script>


<style lang="scss" scoped>
   .disFlex{
       display: flex;
       align-items: center;
       justify-content: space-between;
   }
   .flex2{flex: 2;}
   .flex1{flex: 1;}
   .marR10{margin-right: 10px;}
</style>


// WEBPACK FOOTER //
// src/views/login/upPas.vue